import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { DocumentGeneric } from 'dashboard/models/document';
import { setDocument } from 'dashboard/redux/actions/document-viewer-base';
import { ApiEndpoint } from 'lib/interfaces/api';

export const loadDocument = (id: string) => {
  return async (dispatch: Dispatch) => {
    const documentResponse = await SessionClientDashboard.getResource<DocumentGeneric>(
      ApiEndpoint.Document,
      id,
    );
    const document = documentResponse.data;
    dispatch(setDocument(document));
  };
};
